/* C'est Dosé v10 : badge de réduction en % sur les cartes produits */
(function(){
  function num(el){return el?parseInt((el.textContent||'').replace(/[^\d]/g,''),10)||0:0}
  function run(root){
    (root||document).querySelectorAll('.card-wrapper').forEach(function(c){
      if(c.dataset.cdDone)return;c.dataset.cdDone=1;
      var p=c.querySelector('.price--on-sale');if(!p)return;
      var was=num(p.querySelector('.price__sale s .price-item--regular, .price__sale .price-item--regular')),now=num(p.querySelector('.price__sale .price-item--sale'));
      if(!was||!now||now>=was)return;
      var pct=Math.round((1-now/was)*100);if(pct<1)return;
      var b=c.querySelector('.card__badge .badge');
      if(b){b.textContent='-'+pct+' %';b.classList.add('cd-promo')}
    });
  }
  function tiles(){
    var h=document.querySelector('.cdh');if(!h||h.querySelector('.cdh__side'))return;
    var a=document.createElement('aside');a.className='cdh__side';
    a.innerHTML='<a class="cdh__tile cdh__tile--v" href="/pages/devenir-vendeur"><i aria-hidden="true">🏪</i><b>Vendez sur C\'est Dosé</b><span>Ouvrez votre boutique en 3 minutes</span><em>Commencer ›</em></a>'+
      '<a class="cdh__tile cdh__tile--w" href="/pages/contact" data-cd-support=""><i aria-hidden="true">✉️</i><b>Besoin d\'aide ?</b><span>Notre équipe vous répond par e-mail</span><em>Écrire au support ›</em></a>';
    h.appendChild(a);
  }
  tiles();document.addEventListener('DOMContentLoaded',tiles);
  run();document.addEventListener('DOMContentLoaded',function(){run()});
  var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,250)}).observe(document.documentElement,{childList:true,subtree:true});
})();